/* eslint-disable graphql/template-strings */
/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { DocumentNode } from 'graphql';
import * as apollo from 'apollo-link';
import { gql } from 'graphql-tag';
import { filter, first } from 'rxjs/operators';
import {
  AzzurroEventConfigurationDetail,
} from '..';

import { GraphqlApiService } from '../../graphql-api/graphql-api.service';

const build = (_query: DocumentNode, name = 'QueryResult') => {
  const bQuery = `
  query ${ name }{
    getAzzurroEventsConfigurationList{
      ...azzurroeventconfigurationdetail
    }
  }`;
  return gql`
  ${bQuery}
  ${_query}
`};

@Injectable({
  providedIn: 'root',
})
export class GetAzzurroEventsConfigurationListQuery {
  readonly graphqlClient$ = this.graphqlApiService.client$.pipe(
    filter((available) => !!available),
  );

  readonly build = build;

  constructor(
    private readonly graphqlApiService: GraphqlApiService,
  ) { }

  /**
   * fragment azzurroeventconfigurationdetail on AzzurroEventConfigurationDetail { ... }
   */
  async execute(_query: DocumentNode, refresh = false) {
    const client = await this.graphqlClient$.pipe(first()).toPromise();
    if (!client) {
      throw Error('Missing graphql client!');
    }
    const fetchPolicy = refresh ? 'network-only' : 'cache-first';
   return await client?.query<{ getAzzurroEventsConfigurationList: Partial<AzzurroEventConfigurationDetail>[] }>({ query: build(_query), fetchPolicy });
  }
}
